export const WM_CHANGE_SECTION = 'WM_CHANGE_SECTION';
export const WM_CHANGE_MENU_SECTION = 'WM_CHANGE_MENU_SECTION';
export const WM_CHANGE_WORKSHEET = 'WM_CHANGE_WORKSHEET';
export const WM_CHANGE_SLIDER_VISIBILITY = 'WM_CHANGE_SLIDER_VISIBILITY';
export const WM_INPUT_CHANGED = 'WM_INPUT_CHANGED';
export const WM_INSERT_SPANISH_DISPLAYED = 'WM_INSERT_SPANISH_DISPLAYED';
export const WM_INSERT_SPANISH = 'WM_INSERT_SPANISH';
export const WM_UPDATE_CURSOR_POSITION = 'WM_UPDATE_CURSOR_POSITION';
export const WM_TEACHING_TIPS_MODAL_VISIBLE = 'WM_TEACHING_TIPS_MODAL_VISIBLE';
export const WM_RESET_INPUT_MAP = 'WM_RESET_INPUT_MAP';
